import React from "react";
import CalendarRequestRelationshipConnector from "./CalendarRequestRelationshipConnector";
import GridOrgNameLink from "../common/GridOrgNameLink";
import { useGridOrgNameNavigation } from "../../custom-hooks/useGridOrgNameNavigation";
import {
  resolveProviderDisplayName,
  resolveSponsorDisplayName,
} from "../../utils/calendarRowDisplay";
import { mapCalendarRowToOrgRow } from "../../utils/gridOrgNameLinks";

const VENDOR_COMFORTABLE =
  "text-sm font-semibold leading-5 truncate min-w-0";
const SPONSOR_COMFORTABLE =
  "text-xs font-medium truncate min-w-0";
const SPONSOR_SUBROW =
  "text-xs font-medium truncate min-w-0";

const SPONSOR_SUBROW_COMPACT = "text-[11px] font-medium text-gray-700 truncate min-w-0";
const SPONSOR_COMPACT = SPONSOR_COMFORTABLE.replace("text-xs", "text-[11px]");

function sponsorClassFor(isSubrow, compact) {
  if (isSubrow) return compact ? SPONSOR_SUBROW_COMPACT : SPONSOR_SUBROW;
  return compact ? SPONSOR_COMPACT : SPONSOR_COMFORTABLE;
}

const CalendarVendorSponsorLine = ({ row, isSubrow = false, compact = false }) => {
  const { navigateToHref, vendorHrefForRow, sponsorHrefForRow } =
    useGridOrgNameNavigation();
  const orgRow = mapCalendarRowToOrgRow(row);
  const vendorName = resolveProviderDisplayName(row);
  const sponsorName = row?.is_browse_only ? "" : resolveSponsorDisplayName(row);
  const vendorClass = compact ? VENDOR_COMFORTABLE.replace("text-sm", "text-xs") : VENDOR_COMFORTABLE;
  const sponsorClass = sponsorClassFor(isSubrow, compact);

  if (isSubrow) {
    return (
      <div className="inline-flex min-w-0 max-w-full flex-nowrap items-center gap-1 overflow-hidden">
        <CalendarRequestRelationshipConnector />
        <GridOrgNameLink
          name={sponsorName}
          href={sponsorHrefForRow(orgRow.sponsor_id)}
          onNavigate={navigateToHref}
          className={sponsorClass}
        />
      </div>
    );
  }

  return (
    <div
      className="flex min-w-0 max-w-full flex-nowrap items-center gap-1.5 overflow-hidden"
      aria-label={sponsorName ? `${vendorName} assessment request for ${sponsorName}` : undefined}
    >
      <GridOrgNameLink
        name={vendorName}
        href={vendorHrefForRow(orgRow)}
        onNavigate={navigateToHref}
        className={vendorClass}
      />
      {sponsorName ? (
        <>
          <CalendarRequestRelationshipConnector />
          <GridOrgNameLink
            name={sponsorName}
            href={sponsorHrefForRow(orgRow.sponsor_id)}
            onNavigate={navigateToHref}
            className={sponsorClass}
          />
        </>
      ) : null}
    </div>
  );
};

export default CalendarVendorSponsorLine;
